import { memo, ReactElement, useEffect, useRef } from 'react';
import { ChartContext } from '../types';
import { ChartFiltersUnion } from 'shared/types/analytics';

interface ChartReloaderProps {
  children: ReactElement;
  context: ChartContext<ChartFiltersUnion>;
}

function ChartReloader({ children, context }: ChartReloaderProps): ReactElement {
  const loadRef = useRef(context.load);
  loadRef.current = context.load;

  useEffect(() => {
    loadRef.current?.();
  }, []);

  return children;
}

export const MemoChartReloader = memo(ChartReloader);
